import { Box, IconButton, Stack, SxProps, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowLeftIcon from '@/app/assets/icons/arrow-left.svg?react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  date?: string;
  noBack?: boolean;
  rightComponent?: React.ReactNode;
  sx?: SxProps;
  backUrl?: string;
}

export const PageTitle: FC<Props> = ({
  title,
  date,
  noBack,
  rightComponent,
  sx,
  backUrl: backUrlProp,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const backUrl = decodeURIComponent(backUrlProp || '');

  const handleBack = () => {
    if (backUrl) {
      navigate(backUrl);
    } else {
      navigate(-1);
    }
  };

  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center' sx={sx}>
      <Stack direction='row' spacing={1} alignItems='center' className='page-title-container'>
        {!noBack && (
          <IconButton onClick={handleBack}>
            <ArrowLeftIcon />
          </IconButton>
        )}

        <Typography variant='h5'>
          {title}
          {date && (
            <Box
              component='span'
              sx={{
                fontWeight: 500,
                opacity: 0.5,
              }}
            >
              {' '}
              {t('from_value', { date }).toLowerCase()}
            </Box>
          )}
        </Typography>
      </Stack>
      {rightComponent}
    </Stack>
  );
};
